import { useEffect, useState } from "react";
import { api, snapshotData } from "./api";

const cache = {};
const load = (key, url) => {
  if (!cache[key]) {
    cache[key] = api.get(url).then((r) => r.data).catch((e) => { delete cache[key]; return e?.response?.status === 404 ? "missing" : null; });
  }
  return cache[key];
};
export const refreshKennisbank = () => Object.keys(cache).forEach((k) => delete cache[k]);

// undefined = laden, null = fout, "missing" = bestaat niet (alleen bij één artikel).
const useLoad = (key, url) => {
  const [data, setData] = useState(() => snapshotData(url));
  useEffect(() => {
    let on = true;
    setData(snapshotData(url));
    load(key, url).then((d) => on && setData(d));
    return () => { on = false; };
  }, [key, url]);
  return data;
};

export const useKbCategories = () => useLoad("cats", "/kennisbank/categories");
export const useArticles = () => useLoad("list", "/kennisbank/articles");
export const useArticle = (slug) => useLoad(`a:${slug}`, `/kennisbank/articles/${slug}`);

export const catLabel = (cats, key) => (Array.isArray(cats) ? cats.find((c) => c.key === key)?.label : "") || "";
export const nlDateLong = (iso) => (iso ? new Date(iso.length === 10 ? `${iso}T12:00:00` : iso).toLocaleDateString("nl-NL", { day: "numeric", month: "long", year: "numeric" }) : "");
export const asList = (d) => (Array.isArray(d) ? d : []);

// Gerelateerde artikelen: zelfde categorie eerst, daarna zelfde product, dan de nieuwste.
export const relatedArticles = (list, { category, onderwerp, exclude, limit = 3 }) =>
  asList(list).filter((a) => a.slug !== exclude)
    .map((a) => ({ a, s: (category && a.category === category ? 2 : 0) + (onderwerp && a.onderwerp === onderwerp ? 1 : 0) }))
    .sort((x, y) => y.s - x.s || (y.a.published_at || "").localeCompare(x.a.published_at || ""))
    .slice(0, limit).map((x) => x.a);

// Kennisbankcategorie die bij een product- of informatiepagina hoort.
export const kbCategoryFor = (path = "") => (/gevel|rolluik|dakram/.test(path) ? "aanvullend" : /schuifpui|puien/.test(path) ? "schuifpuien" : /deur/.test(path) ? "deuren" : "kozijnen");
